/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ApplicationView, SystemRoleBit, UserType } from '@gh/builder-shared-data';
import { ApplicationState } from '@gh/common-shared';

export abstract class BuilderApplicationState extends ApplicationState {
  abstract applicationView: ApplicationView;
  abstract userType: UserType;

  abstract isSwitched(): boolean;

  abstract hasSystemRole(role: SystemRoleBit): boolean;
}
